import "./SmallLoader.scss";

const SmallLoader = () => {
    return <div className="small_loader">
            <div className="outer">                
            </div>
            <div className="inner">
            </div>
    </div>
}
export default SmallLoader;